import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import DecideFlow from "@/pages/DecideFlow";
import Decisions from "@/pages/Decisions";
import DecisionDetail from "@/pages/DecisionDetail";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DeleteAccount from "@/pages/DeleteAccount";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Reviewer from "@/pages/Reviewer";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/app" element={<Home />} />
      <Route path="/decide" element={<DecideFlow />} />
      <Route path="/decisions" element={<Decisions />} />
      <Route path="/decisions/:id" element={<DecisionDetail />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/reviewer" element={<Reviewer />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen bg-decide-canvas">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <LanguageProvider>
              <AppRouter />
              <Toaster position="top-center" richColors />
            </LanguageProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
